import * as authStorage from '@/modules/auth/storage'
import constants from '@/util/constants'
import store from '../store'
import infra from '@/util/infra'
import util from '@/util'

const restaurarDadoDaSessao = (dado, mutation) => {
  if (dado) {
    store.dispatch(mutation, dado)
  } else {
    store.dispatch(mutation, '')
    store.dispatch('auth/ActionSignOut')
  }
}

const restaurarDadosSessao = () => {
  const loginStrategy = authStorage.getLoginStrategy()
  restaurarDadoDaSessao(loginStrategy, 'auth/ActionSetLoginStrategy')
  switch (loginStrategy) {
    case constants.loginStrategy.legacyLogin:
      restaurarDadosSessaoJuridico()
      break
    case constants.loginStrategy.managerLogin:
      restaurarDadosSessaoGestaoDeConta()
      break
    default:
      store.dispatch('auth/ActionSignOut')
      break
  }
}

const restaurarDadosSessaoGestaoDeConta = () => {
  restaurarDadoDaSessao(authStorage.getNomeUsuarioLogado(), 'auth/ActionSetNomeUsuarioLogado')
  restaurarDadoDaSessao(authStorage.getNomeEmpresa(), 'auth/ActionSetNomeEmpresa')
  if (!util.valorVazio(authStorage.getCpfCnpj())) {
    restaurarDadoDaSessao(authStorage.getCpfCnpj(), 'auth/ActionSetCpfCnpj')
  }
  if (!util.valorVazio(authStorage.getRegrasLogin())) {
    restaurarDadoDaSessao(authStorage.getRegrasLogin(), 'auth/ActionSetRegrasLogin')
  }
  restaurarDadoDaSessao(authStorage.getEmailUsuario(), 'auth/ActionSetEmailUsuario')
}

const restaurarDadosSessaoJuridico = () => {
  if (possuiPendencia2fa()) {
    restaurarDadoDaSessao(authStorage.getRegrasLogin(), 'auth/ActionSetRegrasLogin')
    return
  }

  restaurarDadoDaSessao(authStorage.getLogoCliente(), 'auth/ActionSetLogoCliente')
  restaurarDadoDaSessao(authStorage.getEscritorio(), 'auth/ActionSetEscritorio')
  restaurarDadoDaSessao(authStorage.getTipoDeAcesso(), 'auth/ActionSetTipoDeAcesso')
  restaurarDadoDaSessao(authStorage.getPerfilUsuario(), 'auth/ActionSetPerfilUsuario')
  restaurarDadoDaSessao(authStorage.getTemAcessoAoFaturamento(), 'auth/ActionSetAcessoFaturamento')
  restaurarDadoDaSessao(authStorage.getFaturamentoContratado(), 'auth/ActionSetFaturamentoContratado')
  restaurarDadoDaSessao(authStorage.getTemAcessoAoFinanceiro(), 'auth/ActionSetAcessoFinanceiro')
  restaurarDadoDaSessao(authStorage.getTemAcessoAosRelatorios(), 'auth/ActionSetAcessoRelatorios')
  restaurarDadoDaSessao(authStorage.getRelatoriosContratado(), 'auth/ActionSetRelatoriosContratado')
  restaurarDadoDaSessao(authStorage.getTemAcessoAoEscritorio(), 'auth/ActionSetAcessoEscritorio')
  restaurarDadoDaSessao(authStorage.getFinanceiroContratado(), 'auth/ActionSetFinanceiroContratado')
  restaurarDadoDaSessao(authStorage.getNomeUsuarioLogado(), 'auth/ActionSetNomeUsuarioLogado')
  restaurarDadoDaSessao(authStorage.getCodigoFotoUsuario(), 'auth/ActionSetCodigoFotoUsuario')
  restaurarDadoDaSessao(authStorage.getEscritorioInadimplente(), 'auth/ActionSetEscritorioInadimplente')
  restaurarDadoDaSessao(authStorage.getDataCriacaoUsuarioLogado(), 'auth/ActionSetDataCriacaoUsuarioLogado')
  restaurarDadoDaSessao(authStorage.getIdUsuarioLogado(), 'auth/ActionSetIdUsuarioLogado')
  restaurarDadoDaSessao(authStorage.getEmailUsuario(), 'auth/ActionSetEmailUsuario')
  restaurarDadoDaSessao(authStorage.getIdEmpresa(), 'auth/ActionSetIdEmpresa')
  restaurarDadoDaSessao(authStorage.getSuporteOnlineHabilitado(), 'auth/ActionSetSuporteOnlineHabilitado')
  restaurarDadoDaSessao(authStorage.getOcultarOpcaoMenuBanco(), 'auth/ActionSetOcultarOpcaoMenuBanco')
  restaurarDadoDaSessao(authStorage.getAlertaStatusEmpresa(), 'auth/ActionSetAlertaStatusEmpresa')
}

const validarSessao = () => {
  const nomeUsuarioLogado = authStorage.getNomeUsuarioLogado()
  const sessaoValida = !!nomeUsuarioLogado
  return sessaoValida
}

const ehPaginaRestrita = (rotaDestino) => {
  return (!Object.values(constants.listaRotasPublicas).includes(rotaDestino.name))
}

const ehPaginaDePendenciasDeLogin = (rotaDestino) => {
  return rotaDestino.name === constants.nomeRotaPendenciasDeLogin
}

const ehPaginaValidacao2faOffice = (rotaDestino) => {
  return rotaDestino.name === 'validacao-2fa-office'
}

const ehPaginaAlteracaoSenhaOffice = (rotaDestino) => {
  return rotaDestino.name === 'alteracao-senha-office'
}

const possuiPendenciaAlteracaoSenhaOffice = () => {
  const regrasLogin = authStorage.getRegrasLogin()

  if (util.valorVazio(regrasLogin)) {
    return false
  }

  const pendenciasDeLogin = JSON.parse(regrasLogin)

  return pendenciasDeLogin.deveAlterarSenha === true
}

const possuiPendencia2fa = () => {
  const regrasLogin = authStorage.getRegrasLogin()

  if (util.valorVazio(regrasLogin)) {
    return false
  }

  const pendenciasDeLogin = JSON.parse(regrasLogin)

  return pendenciasDeLogin.deveValidar2fa === true
}

const existePendenciasDeLogin = (rotaDestino) => {
  const temPendenciasNoStorage = (!!authStorage.getRegrasLogin())
  const temPendenciasNoState = store.getters['auth/temRegrasLogin']
  if (temPendenciasNoStorage || temPendenciasNoState) {
    const temPermissaoAcessoComPendenciaLogin = validarPermissaoAcessoComPendenciaLogin(rotaDestino)
    if (temPermissaoAcessoComPendenciaLogin) {
      return false
    }
    return true
  }

  return false
}

const validarPermissaoAcessoComPendenciaLogin = (rotaDestino) => {
  const pendenciasDeLogin = JSON.parse(authStorage.getRegrasLogin())
  if (pendenciasDeLogin.pagamentoPendente === true) {
    const ehPaginaDeFaturamento = (Object.values(constants.listaRotasFaturamento).includes(rotaDestino.name))
    if (ehPaginaDeFaturamento) {
      return true
    }
  }

  return false
}

const naoEstaNaRotaLoginLite = (rotaDestino) => {
  return (rotaDestino.name !== constants.nomeRotaLoginLite)
}

const ehRotaInicial = (rotaDestino) => {
  return (rotaDestino.name === constants.nomeRotaLogin)
}

const interceptarAcessoManagerConfig = (rotaDestino, rotaOrigem, proximaRota) => {
  const sessaoEstaInvalida = (!validarSessao())
  const naoTemUsuarioNoState = !store.getters['auth/temNomeUsuarioLogado']

  if (ehPaginaRestrita(rotaDestino) && sessaoEstaInvalida) {
    proximaRota({ name: constants.nomeRotaLoginLite })
  } else if (ehPaginaRestrita(rotaDestino) && naoTemUsuarioNoState) {
    proximaRota({ name: constants.nomeRotaLoginLite })
  } else if (!ehPaginaDePendenciasDeLogin(rotaDestino) && naoEstaNaRotaLoginLite(rotaDestino) && existePendenciasDeLogin(rotaDestino)) {
    proximaRota({ name: constants.nomeRotaPendenciasDeLogin })
  } else {
    proximaRota()
  }
}

const interceptarAcessoLegacy = (rotaDestino, rotaOrigem, proximaRota) => {
  const sessaoEstaInvalida = (!validarSessao())
  const naoTemUsuarioNoState = !store.getters['auth/temNomeUsuarioLogado']

  if (ehPaginaValidacao2faOffice(rotaDestino) && possuiPendencia2fa()) {
    proximaRota()
    return
  }

  if (ehPaginaAlteracaoSenhaOffice(rotaDestino) && possuiPendenciaAlteracaoSenhaOffice()) {
    proximaRota()
    return
  }

  if (!ehPaginaAlteracaoSenhaOffice(rotaDestino) && possuiPendenciaAlteracaoSenhaOffice()) {
    proximaRota({ name: 'alteracao-senha-office' })
    return
  }

  if (ehPaginaRestrita(rotaDestino) && sessaoEstaInvalida) {
    proximaRota({ name: constants.nomeRotaLogin })
  } else if (ehPaginaRestrita(rotaDestino) && naoTemUsuarioNoState) {
    proximaRota({ name: constants.nomeRotaLogin })
  } else {
    proximaRota()
  }
}

const interceptarAcesso = (rotaDestino, rotaOrigem, proximaRota) => {
  const loginStrategy = authStorage.getLoginStrategy()
  switch (loginStrategy) {
    case constants.loginStrategy.legacyLogin:
      interceptarAcessoLegacy(rotaDestino, rotaOrigem, proximaRota)
      break
    case constants.loginStrategy.managerLogin:
      interceptarAcessoManagerConfig(rotaDestino, rotaOrigem, proximaRota)
      break
    default:
      const nomeRotaDefault = infra.obterNomeRotaDefault()
      if (ehRotaInicial(rotaDestino) && nomeRotaDefault !== constants.nomeRotaLogin) {
        proximaRota({ name: nomeRotaDefault })
        return
      }
      const ehRotaPublica = (!ehPaginaRestrita(rotaDestino))
      if (ehRotaPublica) {
        proximaRota()
      } else {
        proximaRota({ name: nomeRotaDefault })
      }
      break
  }
}

export default (rotaDestino, rotaOrigem, proximaRota) => {
  document.title = infra.obterTituloPagina()

  restaurarDadosSessao()
  interceptarAcesso(rotaDestino, rotaOrigem, proximaRota)
}
